'use client';

function createHiPPICanvas(canvas, width, height) {
    var _a;
    /*
     * Ref: https://stackoverflow.com/questions/15661339/how-do-i-fix-blurry-text-in-my-html5-canvas
     * */
    canvas.style.width = width + 'px';
    canvas.style.height = height + 'px';
    var ratio = window.devicePixelRatio;
    canvas.width = width * ratio;
    canvas.height = height * ratio;
    (_a = canvas.getContext('2d')) === null || _a === void 0 ? void 0 : _a.scale(ratio, ratio);
    return canvas;
}
/*
 * Curve helper
 * */
var EPSILON = 1e-6;
/**
 * Compute slope from point 'p0' to 'p1'
 * @param {Array} p0
 * @param {Array} p1
 * @returns {Number}
 */
function computeSlope(p0, p1) {
    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
}
/*
 * Find reflection for point to respected point
 * @param {Array} point
 * @param {Array} respected point
 * */
function reflectionPoints(point, respectedPoint) {
    var x = respectedPoint[0] * 2 - point[0];
    var y = respectedPoint[1] * 2 - point[1];
    return [x, y];
}
/**
 * Compute three-point differences for 'points'
 * @param {Array} points
 * @returns {Array}
 */
function finiteDifferences(points) {
    var m = [];
    var p0 = points[0];
    var p1 = points[1];
    var d = (m[0] = computeSlope(p0, p1));
    var i = 1;
    for (var n = points.length - 1; i < n; i++) {
        p0 = p1;
        p1 = points[i + 1];
        m[i] = (d + (d = computeSlope(p0, p1))) * 0.5;
    }
    m[i] = d;
    return m;
}
/**
 * Generate tangents for 'points'
 * @param {Array} points
 * @returns {Array}
 */
function computeTangents(points) {
    var m = finiteDifferences(points);
    var n = points.length - 1;
    var tangents = [];
    var a, b, d, s;
    for (var i = 0; i < n; i++) {
        d = computeSlope(points[i], points[i + 1]);
        if (Math.abs(d) < EPSILON) {
            m[i] = m[i + 1] = 0;
        }
        else {
            a = m[i] / d;
            b = m[i + 1] / d;
            s = a * a + b * b;
            if (s > 9) {
                s = (d * 3) / Math.sqrt(s);
                m[i] = s * a;
                m[i + 1] = s * b;
            }
        }
    }
    for (var i = 0; i <= n; i++) {
        s = (points[Math.min(n, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
        tangents.push([s || 0, m[i] * s || 0]);
    }
    return tangents;
}
/**
 * Convert 'points' to bezier
 * @param {Array} points
 * @returns {Array}
 */
function computePoints(points) {
    var tangents = computeTangents(points);
    var p = points[1];
    var p0 = points[0];
    var pts = [];
    var t = tangents[1];
    var t0 = tangents[0];
    // Add starting 'M' and 'C' points
    pts.push(p0, [p0[0] + t0[0], p0[1] + t0[1], p[0] - t[0], p[1] - t[1], p[0], p[1]]);
    for (var i = 2, n = tangents.length; i < n; i++) {
        var p_1 = points[i];
        var t_1 = tangents[i];
        var prevPts = pts[i - 1];
        var reflectedPoints = reflectionPoints([prevPts[2], prevPts[3]], [prevPts[4], prevPts[5]]);
        pts.push([reflectedPoints[0], reflectedPoints[1], p_1[0] - t_1[0], p_1[1] - t_1[1], p_1[0], p_1[1]]);
    }
    return pts;
}
/* function getControlPoints(x0: number, y0: number, x1: number, y1: number, x2: number, y2: number, t: number) { */
/*     Ref: http://scaledinnovation.com/analytics/splines/aboutSplines.html */
/*     const d01 = Math.sqrt(Math.pow(x1 - x0, 2) + Math.pow(y1 - y0, 2)) */
/*     const d12 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)) */
/*     const fa = (t * d01) / (d01 + d12) // scaling factor for triangle Ta */
/*     const fb = (t * d12) / (d01 + d12) // ditto for Tb, simplifies to fb=t-fa */
/*     const p1x = x1 - fa * (x2 - x0) // x2-x0 is the width of triangle T */
/*     const p1y = y1 - fa * (y2 - y0) // y2-y0 is the height of T */
/*     const p2x = x1 + fb * (x2 - x0) */
/*     const p2y = y1 + fb * (y2 - y0) */
/*     return [p1x, p1y, p2x, p2y] */
/* } */
/*
 * End curve helper
 * */
var canvasHelper = {
    createHiPPICanvas: createHiPPICanvas,
    computePoints: computePoints
};

export { canvasHelper as default };
//# sourceMappingURL=canvas.js.map
